import styled from 'styled-components';

export const StylableDiv = styled.div(({ children, ...props }) => props);
